import type { ValueOf } from '@weft/utils';

export const PATH_CHANGE_STATUS = Object.freeze({
  NONE: 0,
  PARAMS: 1,
  FULL: 2,
});

export type PathChangeStatus = ValueOf<typeof PATH_CHANGE_STATUS>;